import AppMonitoring from 'utilities/monitoring'

type Options = {
  body?: any;
  method?: string;
  signal?: AbortSignal;
};

const NO_CONTENT = 204

// A 204 has no body to parse, so read it as an empty one.
const readBody = (res: Response): Promise<any> =>
  res.status === NO_CONTENT ? Promise.resolve({}) : res.json()

const logError = (error: any, url: string) => {
  // New Relic drops custom attributes that aren't flat primitives, so a nested
  // object here loses the url that makes the error diagnosable.
  AppMonitoring.noticeError(error, { context: 'portalApiFetch', url })
}

export const fetch = (url: string, {
  body,
  method,
  signal,
}: Options) => {
  const organisationScope = localStorage.getItem('organisation_ids') || ''
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'X-Organisation-Scope': organisationScope,
      'Accept': 'application/json'
    },
    credentials: 'include',
    method: method || 'GET',
    body: body && JSON.stringify(body),
    signal,
  } as const
  try {
    return window
      .fetch(url, options)
      .then(async (res) => {
        const { ok, status, statusText } = res
        const json = await readBody(res)
        let response = {
          status: status.toString(),
          statusText,
          ok,
          body: json
        }
        return response
      })
      .catch(e => {
        if (e?.name !== 'AbortError') logError(e, url)
        throw e
      })
  } catch (e: any) {
    if (e?.name !== 'AbortError') logError(e, url)
    throw e
  }
}
